import { ChangeColorIcon, DeleteIcon, EditIcon } from "app/components/Icons";
import ChangeColor from "app/components/Icons/ChangeColor";
import React from "react";

const fixedTagsColorCode = [
  "#ECAEAF",
  "#EDB699",
  "#EFE39E",
  "#CBE674",
  "#A6DBA3",
  "#A4E0CF",
  "#A4D8E2",
  "#A7BFE4",
  "#CAC4EC",
  "#D8BFEB",
  "#EDC7EB",
  "#EFBCCE",
  "#C2C1C1",
];
const actionsOptions = [
  { title: "Rename", actions: "rename", icon: <EditIcon  color="#79808A"/> },
  { title: "Delete", actions: "remove", icon: <DeleteIcon  color="#79808A"/> },
  // { title: "Change color", actions: "changeColor", icon: <ChangeColorIcon color="#79808A"/> },
];

export { fixedTagsColorCode ,actionsOptions};
